import * as THREE from 'three';

export default class BackgroundMap {
    imagePath: string = '/images/FactoryMapDark.jpg';
    plane: THREE.Mesh;
    private material: THREE.MeshBasicMaterial;

    constructor() {
        const texture = new THREE.TextureLoader().load(this.imagePath);
        const geometry = new THREE.PlaneGeometry(629, 629);
        this.material = new THREE.MeshBasicMaterial({ map: texture });
        this.plane = new THREE.Mesh(geometry, this.material);
        this.plane.rotation.x = -Math.PI / 2;
        this.plane.rotation.z = Math.PI / 180 * 326.5;
        this.plane.position.z = -101.5;
        this.plane.position.x = 82;
    }

    public setTexture(newImagePath: string) {
        if (this.imagePath !== newImagePath) {
            this.imagePath = newImagePath;
            const newTexture = new THREE.TextureLoader().load(this.imagePath);
            this.material.map = newTexture;
            this.material.needsUpdate = true;
        }
    }

    public SetPosition(x: number, y: number, z: number) {
        this.plane.position.set(x, y, z);
    }


    getObject3D() {
        return this.plane;
    }
}